var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,20c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6-0.1-0.9-0.2c-1.4-0.5-2.9-1-4.3-1.4c-0.4-0.1-0.7-0.4-1-0.7 C0.1,17.4,0.1,17.2,0,17C0,11.8,0,6.6,0,1.4C0.2,0.6,0.6,0.2,1.4,0c3.3,0,6.5,0,9.8,0c0.4,0,0.8,0.2,1.1,0.4c0.7,0.5,1.1,1.2,1.1,2 c0,0.9,0,1.7,0,2.6c0,0.4-0.2,0.6-0.5,0.8c-0.3,0.2-0.6,0.1-0.9-0.1c-0.2-0.2-0.4-0.4-0.4-0.7c0-0.8,0-1.5,0-2.3c0-0.1,0-0.2,0-0.3 c-0.1-0.4-0.4-0.7-0.8-0.7c-1.1,0-2.2,0-3.3,0c-0.1,0-0.2,0-0.3,0c0.1,0,0.3,0.1,0.4,0.2C7.8,2,7.9,2.1,8,2.3 c0.1,0.1,0.2,0.3,0.2,0.4C8.3,2.9,8.4,3,8.4,3.2c0,0.1,0,0.2,0,0.3c0,4,0,7.9,0,11.9c0,0.1,0,0.1,0,0.2c0,0.3,0,0.3,0.3,0.3 c0.7,0,1.4,0,2.1,0c0.5,0,0.8-0.3,0.8-0.8c0-0.1,0-0.2,0-0.3c0-1,0-2,0-3c0-0.4,0.1-0.6,0.5-0.8c0.6-0.3,1.3,0.1,1.3,0.8 c0,1.2,0,2.4,0,3.5c0,0.9-0.5,1.6-1.3,2c-0.4,0.2-0.9,0.4-1.3,0.3c-0.7,0-1.4,0-2.1,0c-0.3,0-0.3,0-0.3,0.3c0,0.2,0,0.3,0,0.5 c0,0.7-0.4,1.2-1,1.5C7.3,20,7.1,19.9,6.9,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,8.5c-0.1,0.2-0.3,0.4-0.5,0.6c-1,1-2.1,2-3.1,3.1c-0.3,0.3-0.7,0.4-1,0.2C15.1,12.2,15,12,15,11.6 c0-0.8,0-1.5,0-2.3c0-0.2,0-0.2-0.2-0.2c-1,0-2,0-3.1,0c-0.5,0-0.8-0.3-0.9-0.6c-0.1-0.5,0.3-1,0.8-1c1,0,2.1,0,3.1,0 c0.2,0,0.2,0,0.2-0.2c0-0.7,0-1.5,0-2.2c0-0.4,0.2-0.7,0.5-0.8c0.4-0.1,0.7-0.1,0.9,0.2c1.1,1.1,2.2,2.2,3.3,3.3 C19.8,7.9,19.9,8,20,8.2C20,8.3,20,8.4,20,8.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a46e749b.svg";
export { ForwardRef as ReactComponent };